import React from 'react';
import { ListChecks } from 'lucide-react';
import ImagesTab from '../../components/vendor/profile/ImagesTab';
import { VendorPageHeader, VendorGuideCallout } from '../../components/vendor/guidance';
import { VENDOR_PAGE_GUIDES } from '../../utils/vendorPageGuides';

const VendorGallery = () => {
  return (
    <div className="space-y-5">
      <VendorPageHeader
        title="Photo Gallery"
        subtitle="Upload general business photos for branding, invoices, and contracts (separate from Portfolio)."
      />

      <VendorGuideCallout
        title={VENDOR_PAGE_GUIDES.gallery.title}
        steps={VENDOR_PAGE_GUIDES.gallery.steps}
        icon={ListChecks}
      />

      <div className="rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-sm p-4 sm:p-6 lg:p-8">
        <ImagesTab />
      </div>
    </div>
  );
};

export default VendorGallery;
